import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { Tooltip } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import useStyles from './styles';

const IconActionStatusDeny = ({ onClick }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Tooltip
      title={t('edit_certificate_request')}
      arrow
    >
      <EditOutlinedIcon
        onClick={onClick}
        className={classes.icon}
      />
    </Tooltip>
  );
};

export default IconActionStatusDeny;
